var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLoanServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 92,
    viewBox: "0 0 101 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2025_509)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.9948,
    y: 28.46,
    width: 64.8945,
    height: 13.662,
    rx: 6.831,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.23016,
    y: 37.0488,
    width: 63.8659,
    height: 19.0908,
    rx: 9.54542,
    transform: "rotate(-35 5.23016 37.0488)",
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9948,
    y: 42.1221,
    width: 75.141,
    height: 13.662,
    rx: 6.831,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9948,
    y: 55.7842,
    width: 68.31,
    height: 13.662,
    rx: 6.831,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9948,
    y: 69.4463,
    width: 61.479,
    height: 13.662,
    rx: 6.831,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.8256,
    cy: 54.0757,
    rx: 27.324,
    ry: 29.0317,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9937,
    y: 25.043,
    width: 64.8945,
    height: 13.662,
    rx: 6.831,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.22998,
    y: 33.6318,
    width: 63.8659,
    height: 19.0908,
    rx: 9.54542,
    transform: "rotate(-35 5.22998 33.6318)",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9937,
    y: 38.7041,
    width: 75.141,
    height: 13.662,
    rx: 6.831,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9937,
    y: 52.3672,
    width: 68.31,
    height: 13.662,
    rx: 6.831,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9937,
    y: 66.0283,
    width: 61.479,
    height: 13.662,
    rx: 6.831,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.8255,
    cy: 50.6587,
    rx: 27.324,
    ry: 29.0317,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.7334,
    cy: 53.3556,
    rx: 23.9085,
    ry: 18.7852,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.7334,
    cy: 49.9395,
    rx: 23.9085,
    ry: 18.7852,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8747 57.0771L40.7381 38.9657H45.0742L48.2762 51.7071H48.443L51.6783 38.9657H55.9811L59.2498 51.6404H59.4166L62.5853 38.9657H66.9213L61.7848 57.0771H57.3486L53.9464 44.8027H53.713L50.3108 57.0771H45.8747Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2025_509",
    x: 0.501465,
    y: 0.748047,
    width: 99.6343,
    height: 94.7549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2025_509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2025_509",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoanServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcLoanServiceMainMobile.161e537a96fae8846b16d366e829ab3b.svg";
export { ForwardRef as ReactComponent };